<template>
    <div class="InfoBanner">
        <alert-banner v-for="(bannerFields, index) in alertBanners" :key="index" :fields="bannerFields"/>
        <div v-if="bumperBoxEnabled && showBumperBox">
            <custom-banner v-for="(bumperFields, index) in bumperBoxBanner" :key="'BB'+index" :fields="getBumperBoxBannerFields(bumperFields)"/>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AlertBanner, CustomBanner } from '@freddiesflowers/frontend-component-library';
import axios from 'axios';

export default {
    name: 'InfoBanner',
    components: { AlertBanner, CustomBanner },
    props: {
        position: {
            type: String,
            require: true,
        },
    },
    data() {
        return {
            cmsBannersForDashboard: [],
        };
    },
    computed: {
        ...mapGetters({
            userBanners: 'account/getUserBanners',
            bumperBoxEnabled: 'account/getBumperBoxEnabled',
            activeSubscription: 'subscription/getActiveSubscription',
        }),
        dashboardBanners() {
            return this.userBanners?.filter(banner => banner.positions.includes(this.position));
        },
        bumperBoxBanner() {
            return this.cmsBannersForDashboard?.filter(banner => banner.id.toLowerCase().includes('bumperbox'));
        },
        alertBanners() {
            return this.cmsBannersForDashboard?.filter(banner => !banner.id.toLowerCase().includes('bumperbox'));
        },
        showBumperBox() {
            return this.activeSubscription?.product_family !== 'bumper';
        },
    },
    methods: {
        getDashboardBannerData(availableBanners) {
            if (!availableBanners) return;
            this.cmsBannersForDashboard.length = 0;
            if (availableBanners.length) {
                availableBanners.forEach(banner => {
                    let data = this.getBannerFromCms(banner.message_id);
                    data.then(resp => { this.cmsBannersForDashboard.push(resp[0]); });
                });
            }
        },
        async getBannerFromCms(bannerID) {
            const CMSUrl = `https://api.buttercms.com/v2/content/alert_banner/?locale=en&fields.id=${bannerID}&auth_token=6a1c0e28aeba5c9e46b9f4b707b4d42b3b2592a1`;
            const resp = await axios.get(CMSUrl);
            return resp.data.data.alert_banner;
        },
        getBumperBoxBannerFields(bannerFields) {
            return {
                id: bannerFields.id,
                heading: bannerFields.heading,
                message1: bannerFields.message,
                border_style: bannerFields.border_style,
                font_style: bannerFields.font_style,
                image_left: 'https://cdn.buttercms.com/MdpBFhBFRBKD7yzjy1VW',
                call_to_action: 'Find out more',
                href: '/account/bumper-box',
            };
        },
    },
    mounted() {
        this.getDashboardBannerData(this.dashboardBanners);
    },
};
</script>

<style lang="scss" scoped>
.InfoBanner {
    width: 100%;
    margin-top: -10px;
}
</style>
